/** W4 §9.3.1 — in-memory step-up verification (5 min TTL; cleared on logout). */

export const STEP_UP_TTL_MS = 5 * 60_000;

let stepUpVerifiedAt: number | null = null;

export class StepUpRequiredError extends Error {
  constructor() {
    super('STEP_UP_REQUIRED');
    this.name = 'StepUpRequiredError';
  }
}

export function markStepUpVerified(): void {
  stepUpVerifiedAt = Date.now();
}

export function clearStepUpVerified(): void {
  stepUpVerifiedAt = null;
}

export function isStepUpVerified(nowMs = Date.now()): boolean {
  if (stepUpVerifiedAt === null) {
    return false;
  }
  return nowMs - stepUpVerifiedAt <= STEP_UP_TTL_MS;
}

export function assertStepUpVerified(): void {
  if (!isStepUpVerified()) {
    throw new StepUpRequiredError();
  }
}
